/**
 * 本地接口代理
 */

const unitePre = '/boss';
const zmsPre = '/zms';

// 环境列表
const envList = ['dev', 'sit', 'product', 'dev-gray', 'gyl-dev', 'gyl-sit', 'gyl-prond', 'xn-dev', 'pre', 'gyl-pre', 'dev-1', 'test-1', 'test', 'xn-sit', 'tx-sit', 'tx-xn-sit', 'tx-gyl-sit', 'zj-sit'];
// 系统列表
const system = [
  {
    name: '帕拉丁',
    appId: '10011',
  },
  {
    name: '自营',
    appId: '20001',
  },
  {
    name: 'BOSS',
    appId: '10004',
  },
  {
    name: '谛听',
    appId: '10013',
  },
  {
    name: '集团信息化平台',
    appId: '90001',
  },
  {
    name: '客端saas',
    appId: '10016',
  },
  {
    name: '商端CRM',
    appId: '10007',
  },
  {
    name: '众能联合商户',
    appId: '10009',
  },
  {
    name: '线索中台',
    appId: '10015',
  },
  {
    name: '财务工作台',
    appId: '10019',
  },
  {
    name: '律师端',
    appId: '10020',
  },
  {
    name: '大数据',
    appId: '10022',
  },
  {
    name: 'console后台',
    appId: '10023',
  },
  {
    name: '资方供应链平台',
    appId: '20004',
  },
  {
    name: '供应商门户',
    appId: '20030',
  },
  {
    name: '物流管理平台',
    appId: '20008',
  },
  {
    name: '客商融合平台',
    appId: '10025',
  },
];
const proxyList = [
  {
    target: 'https://api-{env}.znlh.work/',
    sysList: [
      '/billing-center',
      '/billing-center',
      '/infrastructure-certificate',
      '/operation-system',
      '/merchant-mbo',
      '/merchant-ddcs',
      '/merchant-esign',
      '/infrastructure-integration',
      '/infrastructure-authority',
      '/trade-goods',
      '/delivery-fulfillment',
      '/trade-order',
      '/transport-system',
      '/finance-gateway',
      '/finance-payment',
      '/finance-billing',
      '/finance-right',
      '/infrastructure-message',
      '/dispatch-traffic',
      '/operation-marketing',
      '/merchant-authority',
      '/crm-customer', // 商机
      '/crm-ccrm', // 大客CRM
      '/trade-order-search',
      '/dispatch-match',
      '/crm-infra',
      '/knowledge',
      '/risk-controlling',
      '/trade-contract',
      '/web-aPaaS',
      '/merchant-order',
      '/demo-paas',
      '/infra-authority',
      '/logistics-manager',
      '/asset-warehouse',
      '/service-center',
      '/infrastructure-workflow',
      '/service-center',
      // '/cust-saas-order',
      '/cust-saas-account',
      '/asset-manager',
      '/bigdata-log-collect',
      '/bigdata-data-query',
      '/apaas-base',
      '/delivery-agreement',
      '/write-off-center',
      '/invoice-center',
      '/accounts-center',
      '/call-center',
      '/asset-accessory',
      '/infrastructure-metadata',
      '/order-manage',
      '/core-ability',
      '/clue-center-system',
      '/core-label',
      '/merchant-themis',
      '/customer-service-system',
      '/customer-service-center',
      '/infrastructure-impexp',
      '/delivery-center',
      '/merchant-scfinance',
      '/merchant-cts',
      '/infrastructure-license',
      '/operation-business-ticket',
      '/infrastructure-console',
      '/finance-settlement',
      '/payment-center',
      '/infrastructure-admin',
      '/infrastructure-sign',
      '/customer-saas-api',
      '/merchant-impexp',
      '/device-center',
      '/merchant-crm',
      '/paas-entity-data',
      '/customer-system',
      '/finance-invoice',
      '/infrastructure-ruleengine',
      '/finance-evidence',
      '/logistics-calculate',
      '/client-bff',
      '/crm-ccrm',
      '/crm-custmer',
      '/aggre-web'
    ],
  },
  {
    target: 'https://legacy-finance-collection-{env}.znlh.work',
    sysList: [
      '/legacy-finance-collection',
    ],
  },
  {
    target: 'https://apioss-{env}.znlh.work/',
    sysList: [
      '/infrastructure-oss',
    ],
  },
  {
    target: 'http://192.168.34.223:8085/',
    sysList: [
      '/dev-carrier',
    ],
  },
  {
    target: 'http://cmdb.znlhzl.org/',
    sysList: [
      '/api/alert',
    ],
  },
  {
    target: 'https://pc-map2code.kaigongla.cn/',
    sysList: [
      '/uploadWithPath',
      '/getCode',
    ],
  },
  {
    target: 'https://api-{env}.znlh.work/',
    sysList: [
      '/client-bff',
      '/cust-saas-order',
    ],
  },
];

const getProxy = () => {
  const data = {};
  envList.forEach((env) => {
    proxyList.forEach((p, index) => {
      p.sysList.forEach((sys) => {
        const curKey = `${unitePre}/${env}${sys}`;
        let curTarget = (p.getTarget ? p.getTarget(env) : p.target).replace('{env}', env);
        if (env === 'product') {
          // 判断正式环境添加target
          curTarget = 'https://api.kaigongla.cn/';
          if (index === 1) {
            // 判断正式环境添加oss服务的target
            curTarget = 'https://apioss.kaigongla.cn/';
          }
          if (index === 3) {
            // 判断正式环境添加oss服务的target
            curTarget = 'http://cmdb.znlhzl.org/';
          }
          if (index === 4) {
            curTarget = 'https://pc-map2code.kaigongla.cn/';
          }
        }
        const rule = `^${curKey}`;
        if (sys === '/dev-carrier' || sys === '/legacy-finance-collection') {
          data[curKey] = {
            target: curTarget,
            secure: false,
            logLevel: 'debug',
            pathRewrite: {
              [rule]: '',
            },
          };
        } else {
          data[curKey] = {
            target: curTarget,
            secure: false,
            logLevel: 'debug',
            pathRewrite: {
              [rule]: sys,
            },
          };
        }
      });
    });
  });
  if (process.env.NODE_ENV === 'development') {
    console.log('proxyConfig', data);
  }
  return data;
};

const getZmsProxy = () => {
  const data = {};
  envList.forEach((env) => {
    proxyList.forEach((p, index) => {
      p.sysList.forEach((sys) => {
        const curKey = `${zmsPre}/${env}${sys}`;
        let curTarget = (p.getTarget ? p.getTarget(env) : p.target).replace('{env}', env);
        if (env === 'product') {
          // 判断正式环境添加target
          curTarget = 'https://api.kaigongla.cn/';
          if (index === 1) {
            // 判断正式环境添加oss服务的target
            curTarget = 'https://apioss.kaigongla.cn/';
          }
          if (index === 3) {
            // 判断正式环境添加oss服务的target
            curTarget = 'http://cmdb.znlhzl.org/';
          }
          if (index === 4) {
            curTarget = 'https://pc-map2code.kaigongla.cn/';
          }
        }
        const rule = `^${curKey}`;
        if (sys === '/legacy-finance-collection') {
          data[curKey] = {
            target: curTarget,
            secure: false,
            logLevel: 'debug',
            pathRewrite: {
              [rule]: '',
            },
          };
        } else {
          data[curKey] = {
            target: curTarget,
            secure: false,
            logLevel: 'debug',
            pathRewrite: {
              [rule]: sys,
            },
          };
        }
      });
    });
  });
  return data;
};

const proxyConfig = {
  '/boss/mock': {
    target: 'https://yapi.znlh.work',
    secure: false,
    logLevel: 'debug',
    pathRewrite: {
      '^/boss/mock': '/mock',
    },
  },
  '/api/get_token': {
    target: 'https://www.soboten.com/',
    secure: false,
    logLevel: 'debug',
  },
  '/tokens/agent': {
    target: 'https://www.soboten.com/',
    secure: false,
    logLevel: 'debug',
  },
  '/api/public/5/agent/query_agents': {
    target: 'https://www.soboten.com/',
    secure: false,
    logLevel: 'debug',
  },
  '/callservice/v6/webmsg/agent/_makeCall': {
    target: 'https://openapi.soboten.com/',
    secure: false,
    logLevel: 'debug',
  },
  ...getProxy(),
  ...getZmsProxy(),
};
module.exports = {
  proxyConfig,
  envList,
  system,
};
